import styled from '@emotion/styled';
import { dataTestId } from '@vromo/models';
import FontAwesome from '@vromo/ui/components/FontAwesome';
import { css } from 'emotion';
import React, { CSSProperties, FC } from 'react';

const Overlay = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.5);
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    user-select: none;
    h2 {
        margin-bottom: 0px;
    }
`;

/** overlays the children content over a white transparency layer, meanwhile active is true */
export const OverlayablePanel: FC<{
    spinner?: boolean;
    active: boolean;
    loadingText?: string;
    style?: CSSProperties;
}> = ({ active, spinner = true, loadingText = 'loading', children, style }) => {
    return (
        <div style={{ position: 'relative', minHeight: '150px', ...style }}>
            {active && (
                <Overlay data-testid={dataTestId.general.componentLoading}>
                    {spinner && <FontAwesome icon="spinner" spin x5 large />}
                    <h2
                        className={css`
                            backgroundcolor: rgba(255, 255, 255, 0.5);
                            margintop: 5%;
                            :first-letter {
                                text-transform: uppercase;
                            }
                        `}>
                        {loadingText}
                    </h2>
                </Overlay>
            )}
            <div
                className={css`
                    opacity: ${active ? 0.5 : 1};
                `}>
                {children}
            </div>
        </div>
    );
};

export default OverlayablePanel;
